import axios from "axios";

const endpoint_url = "/message/messageBlasting/delete";

const deleteBlasting = (messageUuid) => {
  return new Promise((resolve, reject) => {
    axios
      .post(endpoint_url, { message_uuid: messageUuid })
      .then((response) => resolve(response))
      .catch((error) => {
        return reject(error.response.data);
      });
  });
};

export default deleteBlasting;
